import React from 'react';
import BomModal from 'src/components/BomModal';

function SiteBomModal(props) {
  return <BomModal {...props} />;
}

export default SiteBomModal;
